module.exports = __webpack_public_path__ + "img/Delete.c2666561.svg";